import { toString, Union } from "../../fable-library.3.7.17/Types.js";
import { list_type, tuple_type, class_type, string_type, union_type } from "../../fable-library.3.7.17/Reflection.js";
import { CssRuleWithAuto$reflection, CssRuleWithAuto, String$, CssRule$reflection, CssRule, CssRuleWithNone$reflection, CssRuleWithNone, Stringed, UrlMaster, Stringed$reflection, MasterTypeHelpers_stringifyICssValue } from "./MasterTypes.fs.js";
import { map, fold } from "../../fable-library.3.7.17/List.js";
import { Percent$reflection, Angle$reflection, unitHelpers_lengthPercentageString } from "./Units.fs.js";
import { join } from "../../fable-library.3.7.17/String.js";
import { Color_Color$reflection } from "./Color.fs.js";

export class Image_Side extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ClosestSide", "ClosestCorner", "FarthestSide", "FarthestCorner"];
    }
    StringifyCss() {
        const this$ = this;
        switch (this$.tag) {
            case 1: {
                return "closest-corner";
            }
            case 2: {
                return "farthest-side";
            }
            case 3: {
                return "farthest-corner";
            }
            default: {
                return "closest-side";
            }
        }
    }
}

export function Image_Side$reflection() {
    return union_type("Fss.Types.Image.Side", [], Image_Side, () => [[], [], [], []]);
}

export class Image_Shape extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Circle", "Ellipse"];
    }
    StringifyCss() {
        const this$ = this;
        return (this$.tag === 1) ? "ellipse" : "circle";
    }
}

export function Image_Shape$reflection() {
    return union_type("Fss.Types.Image.Shape", [], Image_Shape, () => [[], []]);
}

export class Image_ObjectFit extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Fill", "Contain", "Cover", "ScaleDown"];
    }
    StringifyCss() {
        const this$ = this;
        switch (this$.tag) {
            case 1: {
                return "contain";
            }
            case 2: {
                return "cover";
            }
            case 3: {
                return "scale-down";
            }
            default: {
                return "fill";
            }
        }
    }
}

export function Image_ObjectFit$reflection() {
    return union_type("Fss.Types.Image.ObjectFit", [], Image_ObjectFit, () => [[], [], [], []]);
}

export class Image_Rendering extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["CrispEdges", "Pixelated"];
    }
    StringifyCss() {
        const this$ = this;
        return (this$.tag === 1) ? "pixelated" : "crisp-edges";
    }
}

export function Image_Rendering$reflection() {
    return union_type("Fss.Types.Image.Rendering", [], Image_Rendering, () => [[], []]);
}

export class Image_Image extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Url", "UrlAlt", "LinearGradient", "LinearGradients", "RepeatingLinearGradient", "RepeatingLinearGradients", "RadialGradient", "RadialGradients", "RepeatingRadialGradient", "RepeatingRadialGradients", "ConicGradientAngle", "ConicGradientPercent", "RepeatingConicGradientAngle", "RepeatingConicGradientPercent"];
    }
    StringifyCounter() {
        const this$ = this;
        return MasterTypeHelpers_stringifyICssValue(this$);
    }
    StringifyCss() {
        const this$ = this;
        const gradientToString = (gradients) => fold((acc, tupledArg) => (`${acc}, ${MasterTypeHelpers_stringifyICssValue(tupledArg[0])} ${unitHelpers_lengthPercentageString(tupledArg[1])}`), "", gradients);
        const gradientAngleToString = (gradients_1) => fold((acc_1, tupledArg_1) => (`${acc_1}, ${MasterTypeHelpers_stringifyICssValue(tupledArg_1[0])} ${MasterTypeHelpers_stringifyICssValue(tupledArg_1[1])}`), "", gradients_1);
        const gradientPercentToString = (gradients_2) => fold((acc_2, tupledArg_2) => (`${acc_2}, ${MasterTypeHelpers_stringifyICssValue(tupledArg_2[0])} ${MasterTypeHelpers_stringifyICssValue(tupledArg_2[1])}`), "", gradients_2);
        const linearGradientToString = (tupledArg_3) => (`linear-gradient(${MasterTypeHelpers_stringifyICssValue(tupledArg_3[0])}${gradientToString(tupledArg_3[1])})`);
        const repeatingLinearGradient = (tupledArg_5) => (`repeating-linear-gradient(${MasterTypeHelpers_stringifyICssValue(tupledArg_5[0])}${gradientToString(tupledArg_5[1])})`);
        const radialGradientToString = (tupledArg_7) => {
            let copyOfStruct;
            return `radial-gradient(${((copyOfStruct = tupledArg_7[0], toString(copyOfStruct))).toLocaleLowerCase()} ${MasterTypeHelpers_stringifyICssValue(tupledArg_7[1])} at ${MasterTypeHelpers_stringifyICssValue(tupledArg_7[2])} ${MasterTypeHelpers_stringifyICssValue(tupledArg_7[3])}${gradientToString(tupledArg_7[4])})`;
        };
        const repeatingRadialGradientToString = (tupledArg_9) => {
            let copyOfStruct_1;
            return `repeating-radial-gradient(${((copyOfStruct_1 = tupledArg_9[0], toString(copyOfStruct_1))).toLocaleLowerCase()} ${MasterTypeHelpers_stringifyICssValue(tupledArg_9[1])} at ${MasterTypeHelpers_stringifyICssValue(tupledArg_9[2])} ${MasterTypeHelpers_stringifyICssValue(tupledArg_9[3])}${gradientToString(tupledArg_9[4])})`;
        };
        switch (this$.tag) {
            case 1: {
                return `url(${this$.fields[0]}) / ${MasterTypeHelpers_stringifyICssValue(this$.fields[1])}`;
            }
            case 2: {
                const tupledArg_15 = [this$.fields[0], this$.fields[1]];
                return linearGradientToString([tupledArg_15[0], tupledArg_15[1]]);
            }
            case 3: {
                return join(", ", map((tupledArg_4) => linearGradientToString([tupledArg_4[0], tupledArg_4[1]]), this$.fields[0]));
            }
            case 4: {
                const tupledArg_16 = [this$.fields[0], this$.fields[1]];
                return repeatingLinearGradient([tupledArg_16[0], tupledArg_16[1]]);
            }
            case 5: {
                return join(", ", map((tupledArg_6) => repeatingLinearGradient([tupledArg_6[0], tupledArg_6[1]]), this$.fields[0]));
            }
            case 6: {
                const tupledArg_17 = [this$.fields[0], this$.fields[1], this$.fields[2], this$.fields[3], this$.fields[4]];
                return radialGradientToString([tupledArg_17[0], tupledArg_17[1], tupledArg_17[2], tupledArg_17[3], tupledArg_17[4]]);
            }
            case 7: {
                return join(", ", map((tupledArg_8) => radialGradientToString([tupledArg_8[0], tupledArg_8[1], tupledArg_8[2], tupledArg_8[3], tupledArg_8[4]]), this$.fields[0]));
            }
            case 8: {
                const tupledArg_18 = [this$.fields[0], this$.fields[1], this$.fields[2], this$.fields[3], this$.fields[4]];
                return repeatingRadialGradientToString([tupledArg_18[0], tupledArg_18[1], tupledArg_18[2], tupledArg_18[3], tupledArg_18[4]]);
            }
            case 9: {
                return join(", ", map((tupledArg_10) => repeatingRadialGradientToString([tupledArg_10[0], tupledArg_10[1], tupledArg_10[2], tupledArg_10[3], tupledArg_10[4]]), this$.fields[0]));
            }
            case 10: {
                const tupledArg_19 = [this$.fields[0], this$.fields[1], this$.fields[2], this$.fields[3]];
                const tupledArg_11 = [tupledArg_19[0], tupledArg_19[1], tupledArg_19[2], tupledArg_19[3]];
                return `conic-gradient(from ${MasterTypeHelpers_stringifyICssValue(tupledArg_11[0])} at ${MasterTypeHelpers_stringifyICssValue(tupledArg_11[1])} ${MasterTypeHelpers_stringifyICssValue(tupledArg_11[2])}${gradientAngleToString(tupledArg_11[3])})`;
            }
            case 11: {
                const tupledArg_20 = [this$.fields[0], this$.fields[1], this$.fields[2], this$.fields[3]];
                const tupledArg_12 = [tupledArg_20[0], tupledArg_20[1], tupledArg_20[2], tupledArg_20[3]];
                return `conic-gradient(from ${MasterTypeHelpers_stringifyICssValue(tupledArg_12[0])} at ${MasterTypeHelpers_stringifyICssValue(tupledArg_12[1])} ${MasterTypeHelpers_stringifyICssValue(tupledArg_12[2])}${gradientPercentToString(tupledArg_12[3])})`;
            }
            case 12: {
                const tupledArg_21 = [this$.fields[0], this$.fields[1], this$.fields[2], this$.fields[3]];
                const tupledArg_13 = [tupledArg_21[0], tupledArg_21[1], tupledArg_21[2], tupledArg_21[3]];
                return `repeating-conic-gradient(from ${MasterTypeHelpers_stringifyICssValue(tupledArg_13[0])} at ${MasterTypeHelpers_stringifyICssValue(tupledArg_13[1])} ${MasterTypeHelpers_stringifyICssValue(tupledArg_13[2])}${gradientAngleToString(tupledArg_13[3])})`;
            }
            case 13: {
                const tupledArg_22 = [this$.fields[0], this$.fields[1], this$.fields[2], this$.fields[3]];
                const tupledArg_14 = [tupledArg_22[0], tupledArg_22[1], tupledArg_22[2], tupledArg_22[3]];
                return `repeating-conic-gradient(from ${MasterTypeHelpers_stringifyICssValue(tupledArg_14[0])} at ${MasterTypeHelpers_stringifyICssValue(tupledArg_14[1])} ${MasterTypeHelpers_stringifyICssValue(tupledArg_14[2])}${gradientPercentToString(tupledArg_14[3])})`;
            }
            default: {
                return `url(${this$.fields[0]})`;
            }
        }
    }
}

export function Image_Image$reflection() {
    return union_type("Fss.Types.Image.Image", [], Image_Image, () => [[["Item", string_type]], [["Item1", string_type], ["Item2", Stringed$reflection()]], [["Item1", Angle$reflection()], ["Item2", list_type(tuple_type(Color_Color$reflection(), class_type("Fss.Types.ILengthPercentage")))]], [["Item", list_type(tuple_type(Angle$reflection(), list_type(tuple_type(Color_Color$reflection(), class_type("Fss.Types.ILengthPercentage")))))]], [["Item1", Angle$reflection()], ["Item2", list_type(tuple_type(Color_Color$reflection(), class_type("Fss.Types.ILengthPercentage")))]], [["Item", list_type(tuple_type(Angle$reflection(), list_type(tuple_type(Color_Color$reflection(), class_type("Fss.Types.ILengthPercentage")))))]], [["Item1", Image_Shape$reflection()], ["Item2", Image_Side$reflection()], ["Item3", Percent$reflection()], ["Item4", Percent$reflection()], ["Item5", list_type(tuple_type(Color_Color$reflection(), class_type("Fss.Types.ILengthPercentage")))]], [["Item", list_type(tuple_type(Image_Shape$reflection(), Image_Side$reflection(), Percent$reflection(), Percent$reflection(), list_type(tuple_type(Color_Color$reflection(), class_type("Fss.Types.ILengthPercentage")))))]], [["Item1", Image_Shape$reflection()], ["Item2", Image_Side$reflection()], ["Item3", Percent$reflection()], ["Item4", Percent$reflection()], ["Item5", list_type(tuple_type(Color_Color$reflection(), class_type("Fss.Types.ILengthPercentage")))]], [["Item", list_type(tuple_type(Image_Shape$reflection(), Image_Side$reflection(), Percent$reflection(), Percent$reflection(), list_type(tuple_type(Color_Color$reflection(), class_type("Fss.Types.ILengthPercentage")))))]], [["Item1", Angle$reflection()], ["Item2", Percent$reflection()], ["Item3", Percent$reflection()], ["Item4", list_type(tuple_type(Color_Color$reflection(), Angle$reflection()))]], [["Item1", Angle$reflection()], ["Item2", Percent$reflection()], ["Item3", Percent$reflection()], ["Item4", list_type(tuple_type(Color_Color$reflection(), Percent$reflection()))]], [["Item1", Angle$reflection()], ["Item2", Percent$reflection()], ["Item3", Percent$reflection()], ["Item4", list_type(tuple_type(Color_Color$reflection(), Angle$reflection()))]], [["Item1", Angle$reflection()], ["Item2", Percent$reflection()], ["Item3", Percent$reflection()], ["Item4", list_type(tuple_type(Color_Color$reflection(), Percent$reflection()))]]]);
}

export class ImageClasses_Image {
    constructor() {
    }
}

export function ImageClasses_Image$reflection() {
    return class_type("Fss.Types.ImageClasses.Image", void 0, ImageClasses_Image);
}

export function ImageClasses_Image_url_Z721C83C5(url) {
    return new UrlMaster(0, url);
}

export function ImageClasses_Image_urlAlt_Z384F8060(url, alt) {
    return new Image_Image(1, url, new Stringed(0, alt));
}

export function ImageClasses_Image_linearGradient_2BE92E00(gradients) {
    const tupledArg = gradients;
    return new Image_Image(2, tupledArg[0], tupledArg[1]);
}

export function ImageClasses_Image_linearGradients_Z62CFBBB6(gradients) {
    return new Image_Image(3, gradients);
}

export function ImageClasses_Image_repeatingLinearGradient_2BE92E00(gradients) {
    const tupledArg = gradients;
    return new Image_Image(4, tupledArg[0], tupledArg[1]);
}

export function ImageClasses_Image_repeatingLinearGradients_Z62CFBBB6(gradients) {
    return new Image_Image(5, gradients);
}

export function ImageClasses_Image_radialGradient_64449692(shape, size, x, y, gradients) {
    return new Image_Image(6, shape, size, x, y, gradients);
}

export function ImageClasses_Image_radialGradients_544747B8(gradients) {
    return new Image_Image(7, gradients);
}

export function ImageClasses_Image_repeatingRadialGradient_64449692(shape, size, x, y, gradients) {
    return new Image_Image(8, shape, size, x, y, gradients);
}

export function ImageClasses_Image_conicGradient_Z516D4DFD(angle, x, y, gradients) {
    return new Image_Image(10, angle, x, y, gradients);
}

export function ImageClasses_Image_conicGradient_C015F99(angle, x, y, gradients) {
    return new Image_Image(11, angle, x, y, gradients);
}

export function ImageClasses_Image_repeatingConicGradient_Z516D4DFD(angle, x, y, gradients) {
    return new Image_Image(12, angle, x, y, gradients);
}

export function ImageClasses_Image_repeatingConicGradient_C015F99(angle, x, y, gradients) {
    return new Image_Image(13, angle, x, y, gradients);
}

export class ImageClasses_ImageClass extends CssRuleWithNone {
    constructor(property) {
        super(property);
        this.property_2 = property;
    }
}

export function ImageClasses_ImageClass$reflection() {
    return class_type("Fss.Types.ImageClasses.ImageClass", void 0, ImageClasses_ImageClass, CssRuleWithNone$reflection());
}

export function ImageClasses_ImageClass_$ctor_Z207A3CFB(property) {
    return new ImageClasses_ImageClass(property);
}

export function ImageClasses_ImageClass__url_Z721C83C5(this$, url) {
    const tupledArg = [this$.property_2, ImageClasses_Image_url_Z721C83C5(url)];
    return [tupledArg[0], tupledArg[1]];
}

export function ImageClasses_ImageClass__url_Z384F8060(this$, url, alt) {
    const tupledArg = [this$.property_2, ImageClasses_Image_urlAlt_Z384F8060(url, alt)];
    return [tupledArg[0], tupledArg[1]];
}

export function ImageClasses_ImageClass__linearGradient_2BE92E00(this$, gradients) {
    const tupledArg = [this$.property_2, ImageClasses_Image_linearGradient_2BE92E00(gradients)];
    return [tupledArg[0], tupledArg[1]];
}

export function ImageClasses_ImageClass__linearGradients_Z62CFBBB6(this$, gradients) {
    const tupledArg = [this$.property_2, ImageClasses_Image_linearGradients_Z62CFBBB6(gradients)];
    return [tupledArg[0], tupledArg[1]];
}

export function ImageClasses_ImageClass__repeatingLinearGradient_2BE92E00(this$, gradients) {
    let tupledArg;
    const tupledArg_1 = [this$.property_2, (tupledArg = gradients, new Image_Image(4, tupledArg[0], tupledArg[1]))];
    return [tupledArg_1[0], tupledArg_1[1]];
}

export function ImageClasses_ImageClass__repeatingLinearGradients_Z62CFBBB6(this$, gradients) {
    const tupledArg = [this$.property_2, new Image_Image(5, gradients)];
    return [tupledArg[0], tupledArg[1]];
}

export function ImageClasses_ImageClass__radialGradient_64449692(this$, shape, size, x, y, gradients) {
    const tupledArg = [this$.property_2, new Image_Image(6, shape, size, x, y, gradients)];
    return [tupledArg[0], tupledArg[1]];
}

export function ImageClasses_ImageClass__radialGradients_544747B8(this$, gradients) {
    const tupledArg = [this$.property_2, new Image_Image(7, gradients)];
    return [tupledArg[0], tupledArg[1]];
}

export function ImageClasses_ImageClass__repeatingRadialGradient_64449692(this$, shape, size, x, y, gradients) {
    const tupledArg = [this$.property_2, new Image_Image(8, shape, size, x, y, gradients)];
    return [tupledArg[0], tupledArg[1]];
}

export function ImageClasses_ImageClass__conicGradient_Z516D4DFD(this$, angle, x, y, gradients) {
    const tupledArg = [this$.property_2, new Image_Image(10, angle, x, y, gradients)];
    return [tupledArg[0], tupledArg[1]];
}

export function ImageClasses_ImageClass__conicGradient_C015F99(this$, angle, x, y, gradients) {
    const tupledArg = [this$.property_2, new Image_Image(11, angle, x, y, gradients)];
    return [tupledArg[0], tupledArg[1]];
}

export function ImageClasses_ImageClass__repeatingConicGradient_Z516D4DFD(this$, angle, x, y, gradients) {
    const tupledArg = [this$.property_2, new Image_Image(12, angle, x, y, gradients)];
    return [tupledArg[0], tupledArg[1]];
}

export function ImageClasses_ImageClass__repeatingConicGradient_C015F99(this$, angle, x, y, gradients) {
    const tupledArg = [this$.property_2, new Image_Image(13, angle, x, y, gradients)];
    return [tupledArg[0], tupledArg[1]];
}

export class ImageClasses_ObjectFit extends CssRuleWithNone {
    constructor(property) {
        super(property);
        this.property_2 = property;
    }
}

export function ImageClasses_ObjectFit$reflection() {
    return class_type("Fss.Types.ImageClasses.ObjectFit", void 0, ImageClasses_ObjectFit, CssRuleWithNone$reflection());
}

export function ImageClasses_ObjectFit_$ctor_Z207A3CFB(property) {
    return new ImageClasses_ObjectFit(property);
}

export function ImageClasses_ObjectFit__get_fill(this$) {
    const tupledArg = [this$.property_2, new Image_ObjectFit(0)];
    return [tupledArg[0], tupledArg[1]];
}

export function ImageClasses_ObjectFit__get_contain(this$) {
    const tupledArg = [this$.property_2, new Image_ObjectFit(1)];
    return [tupledArg[0], tupledArg[1]];
}

export function ImageClasses_ObjectFit__get_cover(this$) {
    const tupledArg = [this$.property_2, new Image_ObjectFit(2)];
    return [tupledArg[0], tupledArg[1]];
}

export function ImageClasses_ObjectFit__get_scaleDown(this$) {
    const tupledArg = [this$.property_2, new Image_ObjectFit(3)];
    return [tupledArg[0], tupledArg[1]];
}

export class ImageClasses_ObjectPosition extends CssRule {
    constructor(property) {
        super(property);
        this.property_1 = property;
    }
}

export function ImageClasses_ObjectPosition$reflection() {
    return class_type("Fss.Types.ImageClasses.ObjectPosition", void 0, ImageClasses_ObjectPosition, CssRule$reflection());
}

export function ImageClasses_ObjectPosition_$ctor_Z207A3CFB(property) {
    return new ImageClasses_ObjectPosition(property);
}

export function ImageClasses_ObjectPosition__value_3202B9A0(this$, x, y) {
    const tupledArg = [this$.property_1, new String$(0, `${unitHelpers_lengthPercentageString(x)} ${unitHelpers_lengthPercentageString(y)}`)];
    return [tupledArg[0], tupledArg[1]];
}

export class ImageClasses_ImageRendering extends CssRuleWithAuto {
    constructor(property) {
        super(property);
        this.property_2 = property;
    }
}

export function ImageClasses_ImageRendering$reflection() {
    return class_type("Fss.Types.ImageClasses.ImageRendering", void 0, ImageClasses_ImageRendering, CssRuleWithAuto$reflection());
}

export function ImageClasses_ImageRendering_$ctor_Z207A3CFB(property) {
    return new ImageClasses_ImageRendering(property);
}

export function ImageClasses_ImageRendering__get_crispEdges(this$) {
    const tupledArg = [this$.property_2, new Image_Rendering(0)];
    return [tupledArg[0], tupledArg[1]];
}

export function ImageClasses_ImageRendering__get_pixelated(this$) {
    const tupledArg = [this$.property_2, new Image_Rendering(1)];
    return [tupledArg[0], tupledArg[1]];
}

